import { Component } from '@angular/core';
import { LanguageService } from '../../_services/language.service';

@Component({
  selector: 'app-tooltip-text',
  templateUrl: './tooltip-text.component.html',
  styleUrl: './tooltip-text.component.scss'
})
export class TooltipTextComponent {

  constructor(
    public LanguageService: LanguageService 
  ) { }
}
